import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as extraContent from "./components/extra-content";
import * as a0 from "./components/a-0";
import * as a50 from "./components/a-50";
import * as a100 from "./components/a-100";
import * as b0 from "./components/b-0";
import * as b50 from "./components/b-50";
import * as b100 from "./components/b-100";

const principle: Slide = {
  description:
    "In many classrooms, the existing sound absorption is insufficient to yield optimal acoustic conditions. To reach them, additional sound absorption is needed. Choose between different amounts of additional absorption (0% leaves the room as is, 100% yields optimal conditions according to DIN 18041) and its placement in the room. See how it affects the values of objective parameters. Listen to the sound of a female speaker at two different positions.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {
            label: "Absorption placement&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
          },
          items: [{ name: "A" }, { name: "B" }],
        },
        {
          type: "button",
          options: {
            label: "Extra absorption",
          },
          items: [{ name: "0%" }, { name: "50%" }, { name: "100%" }],
        },
        {
          type: "button",
          options: {
            label: "Parameter",
          },
          items: [{ name: "STI" }, { name: "D<sub>50</sub>" }, { name: "T<sub>30</sub>" }],
        },
      ],
      extraContentLayout: "vertical-reverse",
      extraContent: [
        [
          [extraContent.absorption0, extraContent.absorption0, extraContent.absorption0],
          [extraContent.absorption50a, extraContent.absorption50a, extraContent.absorption50a],
          [extraContent.absorption100a, extraContent.absorption100a, extraContent.absorption100a],
        ],
        [
          [extraContent.absorption0, extraContent.absorption0, extraContent.absorption0],
          [extraContent.absorption50b, extraContent.absorption50b, extraContent.absorption50b],
          [extraContent.absorption100b, extraContent.absorption100b, extraContent.absorption100b],
        ],
      ],
      components: [
        [
          [a0.sti, a0.d50, a0.t30],
          [a50.sti, a50.d50, a50.t30],
          [a100.sti, a100.d50, a100.t30],
        ],
        [
          [b0.sti, b0.d50, b0.t30],
          [b50.sti, b50.d50, b50.t30],
          [b100.sti, b100.d50, b100.t30],
        ],
      ],
    },
  },
};

export default principle;
